"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.needInboundDepartureTimeConfirmation = exports.isEligibleToAutoOrder = exports.isExoneratingAldTransportReason = exports.isLddTransportReason = exports.reasonRules = exports.reasonMappings = exports.getTcAlternativePickupTimeOptions = exports.getAlternativePickupTimeOptions = exports.round = exports.getMtEstimatedPickupTimeOptions = exports.getMtAlternativeDepartureTimeOptions = exports.hasAlternativePickupTime = exports.alternativePickupTimeConfigs = void 0;
exports.getReasonRules = getReasonRules;
exports.getAvailableTransportReasonOptions = getAvailableTransportReasonOptions;
var lodash_1 = require("lodash");
var __1 = require("..");
var moment_1 = __importDefault(require("@ambler/moment"));
exports.alternativePickupTimeConfigs = {
    APT_AROUND: {
        round: { minutes: 15, direction: 'CLOSEST' },
        rangeBefore: 90,
        rangeAfter: 90,
        step: 30,
    },
    APT_BEFORE: {
        round: { minutes: 15, direction: 'BEFORE' },
        rangeBefore: 60,
        rangeAfter: 0,
        step: 15,
    },
    TC_APT_AROUND: {
        round: { minutes: 15, direction: 'CLOSEST' },
        rangeBefore: 120,
        rangeAfter: 120,
        step: 15,
    },
    TC_APT_AFTER: {
        round: { minutes: 30, direction: 'AFTER' },
        rangeBefore: 0,
        rangeAfter: 360,
        step: 30,
    },
};
var hasAlternativePickupTime = function (transportReason) {
    return Boolean(exports.reasonMappings[transportReason].alternativePickupTimeMode);
};
exports.hasAlternativePickupTime = hasAlternativePickupTime;
var isMoment = function (input) {
    return input instanceof moment_1.default;
};
var getMtAlternativeDepartureTimeOptions = function (departureTime, confirmedAt) {
    var now = (0, moment_1.default)();
    var elapsedTimeBetweenConfirmAndDepartureTime = Math.abs((0, moment_1.default)(confirmedAt).diff(departureTime, 'm'));
    return [
        (0, moment_1.default)(departureTime).add(30, 'm'),
        (0, moment_1.default)(departureTime).add(60, 'm'),
        (0, moment_1.default)(departureTime).add(90, 'm'),
        elapsedTimeBetweenConfirmAndDepartureTime >= 75 && (0, moment_1.default)(departureTime).add(120, 'm'),
    ]
        .filter(isMoment)
        .filter(function (m) { return m.isSameOrAfter(now); });
};
exports.getMtAlternativeDepartureTimeOptions = getMtAlternativeDepartureTimeOptions;
var getMtEstimatedPickupTimeOptions = function (departureTime) {
    var remainingTime = (0, moment_1.default)(departureTime).diff((0, moment_1.default)(), 'm');
    if (remainingTime < 95) {
        return [
            remainingTime >= 80 && (0, moment_1.default)(departureTime).subtract(75, 'm'),
            remainingTime >= 65 && (0, moment_1.default)(departureTime).subtract(60, 'm'),
            remainingTime >= 50 && (0, moment_1.default)(departureTime).subtract(45, 'm'),
            remainingTime >= 35 && (0, moment_1.default)(departureTime).subtract(30, 'm'),
            (0, moment_1.default)(departureTime).subtract(15, 'm'),
            (0, moment_1.default)(departureTime),
        ].filter(isMoment);
    }
    return [
        remainingTime >= 185 && (0, moment_1.default)(departureTime).subtract(180, 'm'),
        remainingTime >= 125 && (0, moment_1.default)(departureTime).subtract(120, 'm'),
        (0, moment_1.default)(departureTime).subtract(90, 'm'),
        (0, moment_1.default)(departureTime).subtract(60, 'm'),
        (0, moment_1.default)(departureTime).subtract(30, 'm'),
        (0, moment_1.default)(departureTime),
    ].filter(isMoment);
};
exports.getMtEstimatedPickupTimeOptions = getMtEstimatedPickupTimeOptions;
var round = function (time, interval, direction) {
    var methods = { CLOSEST: Math.round, BEFORE: Math.floor, AFTER: Math.ceil };
    var rounded = methods[direction](time.minute() / interval) * interval;
    return time.minute(rounded).second(0);
};
exports.round = round;
var computeMomentsFromConfig = function (_a) {
    var departureTime = _a.departureTime, arrivalTime = _a.arrivalTime, config = _a.config, nowDate = _a.nowDate;
    var roundedDepartureTime = (0, exports.round)((0, moment_1.default)(departureTime), config.round.minutes, config.round.direction);
    var roundedDropoffTime = (0, exports.round)((0, moment_1.default)(arrivalTime), config.round.minutes, config.round.direction);
    var now = (function () {
        var dateMoment = (0, moment_1.default)(nowDate);
        return dateMoment.isValid() ? dateMoment : (0, moment_1.default)();
    })();
    return __spreadArray(__spreadArray([], Array(config.rangeBefore / config.step)
        .fill(0)
        .map(function (_, k) { return ({
        pickupTime: roundedDepartureTime.clone().subtract((k + 1) * config.step, 'm'),
        dropoffTime: roundedDropoffTime.clone().subtract((k + 1) * config.step, 'm'),
    }); })
        .reverse(), true), Array(config.rangeAfter / config.step)
        .fill(0)
        .map(function (_, k) { return ({
        pickupTime: roundedDepartureTime.clone().add((k + 1) * config.step, 'm'),
        dropoffTime: roundedDropoffTime.clone().add((k + 1) * config.step, 'm'),
    }); }), true).filter(function (m) { return m.pickupTime.isSameOrAfter(now); });
};
var getAlternativePickupTimeOptions = function (_a) {
    var transportReason = _a.transportReason, departureTime = _a.departureTime, arrivalTime = _a.arrivalTime, nowDate = _a.nowDate;
    var alternativePickupTimeMode = exports.reasonMappings[transportReason].alternativePickupTimeMode;
    if (!alternativePickupTimeMode) {
        return [];
    }
    var timeOptions = computeMomentsFromConfig({
        departureTime: departureTime,
        arrivalTime: arrivalTime,
        config: exports.alternativePickupTimeConfigs[alternativePickupTimeMode],
        nowDate: nowDate,
    });
    return timeOptions.map(function (departure) { return ({ pickupTime: departure.pickupTime, dropoffTime: departure.dropoffTime }); });
};
exports.getAlternativePickupTimeOptions = getAlternativePickupTimeOptions;
var getTcAlternativePickupTimeOptions = function (_a) {
    var departureTime = _a.departureTime, arrivalTime = _a.arrivalTime, nowDate = _a.nowDate;
    return (0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], computeMomentsFromConfig({
        departureTime: departureTime,
        arrivalTime: arrivalTime,
        config: exports.alternativePickupTimeConfigs['TC_APT_AROUND'],
        nowDate: nowDate,
    }), true), computeMomentsFromConfig({
        departureTime: departureTime,
        arrivalTime: arrivalTime,
        config: exports.alternativePickupTimeConfigs['TC_APT_AFTER'],
        nowDate: nowDate,
    }), true), function (m) { return m.pickupTime.format('YYYY-MM-DD HH:mm'); });
};
exports.getTcAlternativePickupTimeOptions = getTcAlternativePickupTimeOptions;
var deprecatedReasons = {
    TPS_HOME: { isDeprecated: true, label: 'Transport personnel soignant' },
    ALD_HPTL: { isDeprecated: true, label: 'Chimio, Radiothérapie, Dialyse en centre pour des séances' },
    HC_TSFR_FINAL_NO_CSTMT: {
        isDeprecated: true,
        label: 'Transfert définitif en PSY en soins sans consentement (mesure non levée)',
    },
};
exports.reasonMappings = __assign({ 
    /**
     * HC / FULL
     */
    HC_CS: {
        label: 'Consultation',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Consultation',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        spsTransportReason: 'CONSULTATION',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_RAD_SCAN: {
        label: 'Radio / Scanner',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Radio / Scanner',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        spsTransportReason: 'RADIOGRAPHIE',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_IMAGE_NOT_RAD_SCAN: {
        label: 'Imagerie hors Radio / Scanner',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Imagerie',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        spsTransportReason: 'CONSULTATION',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_IMAGE_AND_CS: {
        label: 'Imagerie + Consultation',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Consultation',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        spsTransportReason: 'CONSULTATION',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_CS_SAFT: {
        label: "Consultation d'un patient en SAFT",
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: null,
        pmtLabel: 'Consultation',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        spsTransportReason: 'CONSULTATION',
        paymentStatus: 'HPTLA',
        isRenewable: true,
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_TSFR_HPTL_TEMP: {
        label: 'Transfert provisoire (1 nuitée max)',
        compatibleHospitalTypes: ['FULL'],
        toggleIsSameMfdType: true,
        pmtIssuer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (isSameMfdType ? 'A' : 'B');
        },
        payer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (isSameMfdType ? 'HPTL_A' : 'HPTL_B');
        },
        govFlatRateClass: function (_a) {
            var isSameMfdType = _a.isSameMfdType, mfdType = _a.mfdType;
            if (!isSameMfdType) {
                return null;
            }
            switch (mfdType) {
                case 'MCO':
                    return null;
                case 'SSR':
                    return 'ST5';
                case 'PSY':
                    return 'ST2';
            }
            (0, __1.assertUnreachable)(mfdType);
        },
        pmtLabel: 'Transfert',
        prefillOriginWithMfuPlace: true,
        needGovFlatRateTempTransferWarning: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        spsTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_TEMP',
        relatedGovFlatRateReason: 'HC_TSFR_FINAL',
        paymentStatus: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            if (isSameMfdType) {
                return 'HPTLA';
            }
            return 'HPTLA_HPTLB';
        },
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_TSFR_URG_FINAL: {
        label: 'Transfert définitif aux urgences',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: 'TDE',
            SSR: 'ST4',
            PSY: 'ST1',
        },
        pmtLabel: 'Transfert',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'URGENCES',
        isSingleTrip: true,
        isUrgent: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        spsTransportReason: 'MEDECIN',
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_FINAL',
        relatedGovFlatRateReason: 'HC_TSFR_URG_TMP_EXAM',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_ENTER_PIA: {
        label: 'Transfert provisoire (1 nuitée max) vers votre établissement',
        compatibleHospitalTypes: ['FULL'],
        toggleIsSameMfdType: true,
        pmtIssuer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (!isSameMfdType ? 'A' : 'B');
        },
        payer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (isSameMfdType ? 'HPTL_B' : 'HPTL_A');
        },
        govFlatRateClass: function (_a) {
            var isSameMfdType = _a.isSameMfdType, mfdType = _a.mfdType;
            if (isSameMfdType) {
                return null;
            }
            switch (mfdType) {
                case 'MCO':
                    return null;
                case 'SSR':
                    return 'ST5';
                case 'PSY':
                    return 'ST2';
            }
            (0, __1.assertUnreachable)(mfdType);
        },
        pmtLabel: 'Transfert',
        prefillDestinationWithMfuPlace: true,
        needGovFlatRateTempTransferWarning: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        spsTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            if (isSameMfdType) {
                return 'HPTLA_HPTLB';
            }
            return 'HPTLA';
        },
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_EXIT_BABY: {
        label: 'Retour hospitalisation nouveau né',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: null,
        prefillDestinationWithMfuPlace: true,
        isSingleTrip: true,
        pmtLabel: 'Transfert',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, HC_TSFR_FINAL: {
        label: 'Transfert définitif',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: 'TDE',
            SSR: 'ST4',
            PSY: 'ST1',
        },
        pmtLabel: 'Transfert',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        spsTransportReason: 'TRANFERT',
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_FINAL',
        relatedGovFlatRateReason: 'HC_TSFR_HPTL_TEMP',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        patientSector: 'DEPARTURE',
    }, HC_TSFR_FINAL_CTRTE: {
        label: 'Transfert définitif sous contrainte vers un autre établissement',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: null,
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA_HPTLB',
        isUrgentAsap: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, HC_TSFR_FINAL_ENTER_CTRTE: {
        label: 'Transfert définitif sous contrainte vers mon établissement',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        pmtLabel: 'Transfert',
        govFlatRateClass: null,
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, HC_ENTER_HPTL: {
        label: 'Entrée en hospitalisation depuis un domicile / EHPAD / USLD',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_IN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        pmtLabel: 'Entrée',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, HC_SRE_DETAINEE: {
        label: "Transport sous responsabilité de l'état d'un détenu",
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: null,
        pmtLabel: 'Transfert',
        prefillOriginWithMfuPlace: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'PAS_DE_RAISON',
        patientSector: 'DEPARTURE',
    }, HC_SRE_NOT_DETAINEE: {
        label: "Transport sous responsabilité de l'état d'un patient NON détenu",
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: null,
        cerfaArrival: null,
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'HOSP_IN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        pmtLabel: 'Transfert',
        spsTransportReason: 'PAS_DE_RAISON',
        patientSector: 'DEPARTURE',
    }, HC_ENTER_CTRTE: {
        label: "Entrée d'un patient en hospitalisation sous demande d'un tiers",
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_IN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        pmtLabel: 'Entrée',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, HC_CS_FROM_DOM: {
        label: 'Consultation depuis un domicile / EHPAD / USLD pour un patient non hospitalisé',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        pmtLabel: 'Consultation',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HC_FUGUE: {
        label: 'Retour de fugue',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: {
            PSY: 'A',
            SSR: null,
            MCO: null,
        },
        payer: {
            PSY: 'HPTL_A',
            SSR: null,
            MCO: null,
        },
        govFlatRateClass: {
            PSY: 'ST1',
            SSR: null,
            MCO: null,
        },
        pmtLabel: 'Retour de fugue',
        prefillDestinationWithMfuPlace: true,
        isSingleTrip: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: function (_a) {
            var mfdType = _a.mfdType;
            if (mfdType === 'PSY') {
                return 'HPTLA';
            }
            return null;
        },
        spsTransportReason: 'PAS_DE_RAISON',
        patientSector: 'DEPARTURE',
    }, HC_TRIBUNAL: {
        label: 'Rendez-vous tribunal',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: null,
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLA',
        pmtLabel: 'Transfert',
        spsTransportReason: 'PAS_DE_RAISON',
        patientSector: 'DEPARTURE',
    }, HC_TSFR_ATTENTE: {
        label: "Retour d'hébergement vers son secteur (faute de place)",
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: {
            PSY: 'A',
            SSR: null,
            MCO: null,
        },
        payer: {
            PSY: 'HPTL_A',
            SSR: null,
            MCO: null,
        },
        govFlatRateClass: {
            PSY: 'ST1',
            SSR: null,
            MCO: null,
        },
        pmtLabel: 'Transfert',
        prefillDestinationWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: function (_a) {
            var mfdType = _a.mfdType;
            if (mfdType === 'PSY') {
                return 'HPTLA';
            }
            return null;
        },
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, HC_CHIM_HPTL: {
        label: 'Séance de chimiothérapie en centre',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'CHIMIOTHERAPIE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        pmtLabel: 'Chimiothérapie',
        spsTransportReason: 'CHIMIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, HC_DIALYSIS_HPTL: {
        label: 'Séance de dialyse en centre',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'DIALYSE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        pmtLabel: 'Dialyse',
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, HC_AUTO_DIALYSIS: {
        label: "Séance d'auto-dialyse",
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'DIALYSE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        pmtLabel: 'Dialyse',
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, HC_RADIO_HPTL: {
        label: 'Séance de radiothérapie en centre',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'RADIOTHERAPIE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLB',
        pmtLabel: 'Radiothérapie',
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, HC_RADIO_NOT_HPTL: {
        label: 'Séance de radiothérapie en structure libérale',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'B',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        isGovBIssuer: true,
        paymentStatus: 'GOV',
        isExoneratingAld: true,
        pmtLabel: 'Radiothérapie',
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, HC_DIALYSIS_NOT_HPTL: {
        label: 'Dialyse hors centre',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: {
            MCO: 'A',
            SSR: 'B',
            PSY: 'B',
        },
        payer: {
            MCO: 'HPTL_A',
            SSR: 'HPTL_B',
            PSY: 'HPTL_B',
        },
        pmtLabel: 'Dialyse',
        govFlatRateClass: {
            MCO: 'TSE',
            SSR: null,
            PSY: null,
        },
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'DIALYSE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, HC_PERM_CHILD: {
        label: 'Permission thérapeutique pour un enfant de moins de 20 ans hospitalisé depuis plus de 14 jours',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'HOME',
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        needPermissionWarning: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_OUT',
        paymentStatus: 'GOV',
        pmtLabel: 'Permission',
        spsTransportReason: 'SORTIE_THERAPEUTIQUE',
        patientSector: 'ARRIVAL',
    }, HC_PERM: {
        label: 'Permission thérapeutique (48h max)',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST6',
            PSY: 'ST3',
        },
        pmtLabel: 'Permission',
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        needPermissionWarning: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_OUT',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'SORTIE_THERAPEUTIQUE',
        patientSector: 'ARRIVAL',
    }, HC_VISIT_EHPAD: {
        label: 'Visite de pré-admission en EHPAD',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'GOV',
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'OTHER',
        isHidden: true,
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, HC_VISIT_EHPAD_PTNT: {
        label: 'Visite de pré-admission en EHPAD à la charge du patient',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'PTNT',
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'PTNT',
        pmtLabel: 'Visite',
        spsTransportReason: 'CONVENANCE_PERSONNELLE',
        patientSector: 'ARRIVAL',
    }, HC_VISIT_EHPAD_HPTL: {
        label: 'Visite de pré-admission en EHPAD à la charge de votre établissement',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST6',
            PSY: 'ST3',
        },
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        pmtLabel: 'Visite',
        spsTransportReason: 'EXAMEN',
        patientSector: 'ARRIVAL',
    }, HC_VAD: {
        label: 'Visite à domicile',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST6',
            PSY: 'ST3',
        },
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        appsoluTransportReason: 'HOSP_OUT',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        pmtLabel: 'Visite',
        spsTransportReason: 'EXAMEN',
        patientSector: 'ARRIVAL',
    }, HC_PERM_EHPAD_HPTL: {
        label: 'Permission de sortie vers un EHPAD pour motif thérapeutique',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST6',
            PSY: 'ST3',
        },
        prefillOriginWithMfuPlace: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        pmtLabel: 'Consultation',
        spsTransportReason: 'SORTIE_THERAPEUTIQUE',
        patientSector: 'ARRIVAL',
    }, HC_PERM_EHPAD_PTNT: {
        label: 'Permission de sortie vers un EHPAD pour convenance personnelle',
        compatibleHospitalTypes: ['FULL'],
        payer: 'PTNT',
        prefillOriginWithMfuPlace: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'PTNT',
        pmtIssuer: 'A',
        pmtLabel: 'Consultation',
        spsTransportReason: 'SORTIE_THERAPEUTIQUE',
        patientSector: 'ARRIVAL',
    }, HC_TSFR_URG_TMP_EXAM: {
        label: 'Transfert provisoire aux urgences',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Transfert',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'URGENCES',
        isUrgent: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_TEMP',
        relatedGovFlatRateReason: 'HC_TSFR_URG_FINAL',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'MEDECIN',
        patientSector: 'DEPARTURE',
    }, HC_TSFR_URG_TMP_HOSPI: {
        label: 'Transfert provisoire aux urgences en UHCD ou en UPHU (hospitalisation)',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: {
            PSY: null,
            SSR: null,
            MCO: 'A',
        },
        payer: {
            PSY: 'HPTL_B',
            SSR: 'HPTL_B',
            MCO: 'HPTL_A',
        },
        govFlatRateClass: {
            PSY: 'ST2',
            SSR: 'ST5',
            MCO: null,
        },
        pmtLabel: 'Transfert',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'URGENCES',
        isUrgent: true,
        prefillSameDayUnknownTime: true,
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_TEMP',
        relatedGovFlatRateReason: 'HC_TSFR_URG_FINAL',
        paymentStatus: function (_a) {
            var mfdType = _a.mfdType;
            if (mfdType === 'MCO') {
                return 'HPTLA';
            }
            return 'HPTLA_HPTLB';
        },
        isUrgentAsap: true,
        spsTransportReason: 'MEDECIN',
        patientSector: 'DEPARTURE',
    }, HC_SISMO: {
        label: 'Sismothérapie / ECT',
        compatibleHospitalTypes: ['FULL'],
        toggleIsSameMfdType: true,
        pmtIssuer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (isSameMfdType ? 'A' : 'B');
        },
        payer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (isSameMfdType ? 'HPTL_A' : 'HPTL_B');
        },
        govFlatRateClass: function (_a) {
            var isSameMfdType = _a.isSameMfdType, mfdType = _a.mfdType;
            if (!isSameMfdType) {
                return null;
            }
            switch (mfdType) {
                case 'MCO':
                    return null;
                case 'SSR':
                    return 'ST5';
                case 'PSY':
                    return 'ST2';
            }
            (0, __1.assertUnreachable)(mfdType);
        },
        pmtLabel: 'Sismothérapie',
        prefillOriginWithMfuPlace: true,
        needGovFlatRateTempTransferWarning: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            if (isSameMfdType) {
                return 'HPTLA';
            }
            return 'HPTLA_HPTLB';
        },
        isUrgentAsap: true,
        isRenewable: true,
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, HC_KINE: {
        label: 'Consultation',
        compatibleHospitalTypes: ['FULL'],
        pmtIssuer: 'A',
        payer: {
            MCO: 'HPTL_A',
            SSR: 'HPTL_A',
            PSY: 'HPTL_A',
        },
        govFlatRateClass: function (_a) {
            var mfdType = _a.mfdType;
            switch (mfdType) {
                case 'SSR':
                    return 'ST5';
                case 'PSY':
                    return 'ST2';
                case 'MCO':
                    return null;
            }
            (0, __1.assertUnreachable)(mfdType);
        },
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        pmtLabel: 'Consultation',
        isUrgentAsap: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLA',
        alternativePickupTimeMode: 'APT_BEFORE',
        spsTransportReason: 'KINESITHERAPIE',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * URGENCES
     */
    URG_TSFR_UHCD_HPTL: {
        label: "Transfert d'un patient hospitalisé en UHCD vers un autre établissement pour hospitalisation",
        compatibleHospitalTypes: ['URG'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TDE',
        pmtLabel: 'Transfert',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        isUrgent: true,
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, URG_CS: {
        label: "Consultation d'un patient hospitalisé en UHCD",
        compatibleHospitalTypes: ['URG'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: null,
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        pmtLabel: 'Consultation',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, URG_TSFR_HPTL: {
        label: "Transfert d'un patient NON hospitalisé en UHCD vers un autre établissement",
        compatibleHospitalTypes: ['URG'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        isUrgent: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, URG_ENTER_UHCD: {
        label: "Entrée pour hospitalisation < 48h en UHCD d'un patient hospitalisé dans un autre établissement",
        compatibleHospitalTypes: ['URG'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: null,
        pmtLabel: 'Entrée',
        prefillDestinationWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        isUrgent: true,
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, URG_TSFR_PSYCONS: {
        label: "Transfert d'un patient sous contrainte non hospitalisé vers son centre psychiatrique",
        compatibleHospitalTypes: ['URG'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        isUrgent: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, URG_TSFR_PSYCONS_FROM_UHCD: {
        label: "Transfert d'un patient hospitalisé en UHCD sous contrainte vers son centre psychiatrique",
        compatibleHospitalTypes: ['URG'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA_HPTLB',
        isUrgent: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * EHPAD / USLD
     */
    EHPAD_CS: {
        label: 'Consultation',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Consultation',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EHPAD_RAD_SCAN: {
        label: 'Radio / Scanner',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Radio / Scanner',
        spsTransportReason: 'SCANNER',
        patientSector: 'DEPARTURE',
    }, EHPAD_IMAGE_NOT_RAD_SCAN: {
        label: 'Imagerie hors Radio / Scanner',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Imagerie',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EHPAD_IMAGE_AND_CS: {
        label: 'Imagerie + Consultation',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Consultation',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EHPAD_TSFR_HPTL_TEMP: {
        label: 'Transfert provisoire (1 nuitée max)',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, EHPAD_TSFR_URG_TMP_EXAM: {
        label: 'Transfert provisoire aux urgences',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'URGENCES',
        isUrgent: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Urgences',
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, EHPAD_TSFR_URG_FINAL: {
        label: 'Transfert définitif aux urgences',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'URGENCES',
        isSingleTrip: true,
        isUrgent: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, EHPAD_TSFR_FINAL: {
        label: 'Transfert définitif',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, EHPAD_ENTER: {
        label: 'Entrée en EHPAD / USLD',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_IN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        pmtLabel: 'Entrée',
        spsTransportReason: 'DEF_RETOUR_DOMICILE',
        patientSector: 'ARRIVAL',
    }, EHPAD_PERM: {
        label: 'Permission à la charge du patient',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'PTNT',
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_OUT',
        paymentStatus: 'PTNT',
        spsTransportReason: 'CONVENANCE_PERSONNELLE',
        pmtLabel: 'Permission',
        patientSector: 'DEPARTURE',
    }, EHPAD_RADIO: {
        label: 'Séance de radiothérapie',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'B',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'RADIOTHERAPIE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        isGovBIssuer: true,
        paymentStatus: 'GOV',
        isExoneratingAld: true,
        pmtLabel: 'Radiothérapie',
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, EHPAD_CHIM: {
        label: 'Séance de chimiothérapie',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'B',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'CHIMIOTHERAPIE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        isGovBIssuer: true,
        paymentStatus: 'GOV',
        pmtLabel: 'Chimiothérapie',
        spsTransportReason: 'CHIMIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, EHPAD_DIALYSIS: {
        label: 'Séance de dialyse',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'B',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'DIALYSE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        isGovBIssuer: true,
        paymentStatus: 'GOV',
        isExoneratingAld: true,
        pmtLabel: 'Dialyse',
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, EHPAD_DC_CH_RA: {
        label: 'Séances de Chimio, Radiothérapie, Dialyse en centre',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'B',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'DIALYSE',
        appsoluTransportReason: 'EXAMEN',
        isGovBIssuer: true,
        paymentStatus: 'GOV',
        isExoneratingAld: true,
        spsTransportReason: 'LONGUE_DUREE',
        patientSector: 'DEPARTURE',
    }, EHPAD_ADJ: {
        label: 'Accueil de jour',
        compatibleHospitalTypes: ['EHPAD'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        pmtLabel: 'Consultation',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isRenewable: true,
        paymentStatus: 'HPTLA',
        spsTransportReason: 'EXAMEN',
        patientSector: 'ARRIVAL',
    }, 
    /**
     * HDJ
     */
    HDJ_FROM_DOM: {
        label: 'Transport domicile - HDJ',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_IN',
        timeStepInMinutes: 5,
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        isEligibleToAutoOrder: true,
        pmtLabel: 'Consultation',
        spsTransportReason: 'HOPITAL_DE_JOUR',
        patientSector: 'DEPARTURE',
    }, HDJ_TSFR_DOM_FROM_HDJ: {
        label: 'Transport HDJ - domicile',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'HOME',
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        isSingleTrip: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_OUT',
        timeStepInMinutes: 5,
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        pmtLabel: 'Consultation',
        spsTransportReason: 'HOPITAL_DE_JOUR',
        patientSector: 'ARRIVAL',
    }, HDJ_TSFR_ECOLE_FROM_HDJ: {
        label: 'Transport HDJ - Ecole à charge CPAM',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'OTHER',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        timeStepInMinutes: 5,
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        pmtLabel: 'École',
        spsTransportReason: 'HOPITAL_DE_JOUR',
        patientSector: 'ARRIVAL',
    }, HDJ_TSFR_HDJ_FROM_ECOLE: {
        label: 'Transport Ecole - HDJ à charge CPAM',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'OTHER',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        isSingleTrip: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        timeStepInMinutes: 5,
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        pmtLabel: 'École',
        spsTransportReason: 'HOPITAL_DE_JOUR',
        patientSector: 'DEPARTURE',
    }, HDJ_ACTIVITIES_FROM_HDJ: {
        label: 'Transport activités thérapeutiques depuis HDJ',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'OTHER',
        prefillOriginWithMfuPlace: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        pmtLabel: 'Activités thérapeutiques',
        spsTransportReason: 'HOPITAL_DE_JOUR',
        patientSector: 'DEPARTURE',
    }, HDJ_ACTIVITIES_FROM_DOM: {
        label: 'Transport activités thérapeutiques depuis le domicile',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'OTHER',
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        pmtLabel: 'Activités thérapeutiques',
        spsTransportReason: 'HOPITAL_DE_JOUR',
        patientSector: 'DEPARTURE',
    }, HDJ_CS: {
        label: 'Consultation',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'ST2',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        pmtLabel: 'Consultation',
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HDJ_IMAGE_AND_CS: {
        label: 'Imagerie + Consultation',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'ST2',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        pmtLabel: 'Consultation',
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HDJ_RAD_SCAN: {
        label: 'Radio / Scanner',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'ST2',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        pmtLabel: 'Radio / Scanner',
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'SCANNER',
        patientSector: 'DEPARTURE',
    }, HDJ_IMAGE_NOT_RAD_SCAN: {
        label: 'Imagerie hors Radio / Scanner',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'ST2',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        pmtLabel: 'Imagerie',
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HDJ_TSFR_OTHER_FROM_HDJ_HPTLA_NOTART80: {
        label: 'AS MF - Autre à charge HPTL_A_NOTART80',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, HDJ_TSFR_HDJ_FROM_OTHER_HPTLA_NOTART80: {
        label: 'AS Autre - MF à charge HPTL_A_NOTART80',
        compatibleHospitalTypes: ['HDJ'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillDestinationWithMfuPlace: true,
        isSingleTrip: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, HDJ_ENTER_PIA: {
        label: 'Transfert provisoire (1 nuitée max) vers votre établissement',
        compatibleHospitalTypes: ['HDJ'],
        toggleIsSameMfdType: true,
        pmtIssuer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (!isSameMfdType ? 'A' : 'B');
        },
        payer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (!isSameMfdType ? 'HPTL_A' : 'HPTL_B');
        },
        govFlatRateClass: function (_a) {
            var isSameMfdType = _a.isSameMfdType, mfdType = _a.mfdType;
            if (isSameMfdType) {
                return null;
            }
            switch (mfdType) {
                case 'MCO':
                    return null;
                case 'SSR':
                    return 'ST5';
                case 'PSY':
                    return 'ST2';
            }
            (0, __1.assertUnreachable)(mfdType);
        },
        pmtLabel: 'Transfert',
        prefillDestinationWithMfuPlace: true,
        needGovFlatRateTempTransferWarning: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            if (isSameMfdType) {
                return 'HPTLA_HPTLB';
            }
            return 'HPTLA';
        },
        isUrgentAsap: true,
        isAldInvoiceable: true,
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * HAD
     */
    HAD_CS_PRTCL: {
        label: 'Consultation',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Consultation',
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HAD_CS_NOT_PRTCL: {
        label: 'Consultation',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Consultation',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HAD_RAD_SCAN_PRTCL: {
        label: 'Radio / Scanner',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Radio / Scanner',
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'SCANNER',
        patientSector: 'DEPARTURE',
    }, HAD_RAD_SCAN_NOT_PRTCL: {
        label: 'Radio / Scanner',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Radio / Scanner',
        spsTransportReason: 'SCANNER',
        patientSector: 'DEPARTURE',
    }, HAD_IMAGE_NOT_RAD_SCAN_PRTCL: {
        label: 'Imagerie hors Radio / Scanner',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Imagerie',
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HAD_IMAGE_NOT_RAD_SCAN_NOT_PRTCL: {
        label: 'Imagerie hors Radio / Scanner',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Imagerie',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HAD_IMAGE_AND_CS_PRTCL: {
        label: 'Imagerie + Consultation',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: {
            MCO: null,
            SSR: 'ST5',
            PSY: 'ST2',
        },
        pmtLabel: 'Consultation',
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HAD_PSY_SSR_IMAGE_AND_CS_NOT_PRTCL: {
        label: 'Imagerie + Consultation',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Consultation',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, HAD_TSFR_HPTL_TEMP_PRTCL: {
        label: 'Transfert provisoire (1 nuitée max)',
        compatibleHospitalTypes: ['HAD'],
        toggleIsSameMfdType: true,
        pmtIssuer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (isSameMfdType ? 'A' : 'B');
        },
        payer: function (_a) {
            var isSameMfdType = _a.isSameMfdType;
            return (isSameMfdType ? 'HPTL_A' : 'HPTL_B');
        },
        govFlatRateClass: function (_a) {
            var isSameMfdType = _a.isSameMfdType, mfdType = _a.mfdType;
            if (!isSameMfdType) {
                return null;
            }
            switch (mfdType) {
                case 'MCO':
                    return null;
                case 'SSR':
                    return 'ST5';
                case 'PSY':
                    return 'ST2';
            }
            (0, __1.assertUnreachable)(mfdType);
        },
        pmtLabel: 'Transfert',
        originPlaceHolderHome: true,
        needGovFlatRateTempTransferWarning: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_TEMP',
        relatedGovFlatRateReason: 'HAD_TSFR_FINAL',
        paymentStatus: function (_a) {
            var isSameMfdType = _a.isSameMfdType, mfdType = _a.mfdType;
            if (!isSameMfdType) {
                return 'HPTLA_HPTLB';
            }
            switch (mfdType) {
                case 'MCO':
                case 'SSR':
                    return 'GOV';
                case 'PSY':
                    return 'HPTLA';
            }
            (0, __1.assertUnreachable)(mfdType);
        },
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, HAD_TSFR_HPTL_TEMP_NOT_PRTCL: {
        label: "Transfert provisoire d'un patient HAD sans lien avec la raison d'hospitalisation",
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, HAD_TSFR_FINAL: {
        label: 'Transfert définitif',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_FINAL',
        relatedGovFlatRateReason: 'HAD_TSFR_HPTL_TEMP_PRTCL',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, HAD_ENTER: {
        label: 'Admission en HAD',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'HOME',
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_IN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        pmtLabel: 'Admission',
        spsTransportReason: 'DEF_RETOUR_DOMICILE',
        patientSector: 'ARRIVAL',
    }, HAD_CHIM_HPTL: {
        label: 'Séance de chimiothérapie en centre',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        originPlaceHolderHome: true,
        prefillDestinationServiceRaw: 'CHIMIOTHERAPIE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        pmtLabel: 'Chimiothérapie',
        spsTransportReason: 'CHIMIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, HAD_DIALYSIS_HPTL: {
        label: 'Séance de dialyse en centre',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        originPlaceHolderHome: true,
        prefillDestinationServiceRaw: 'DIALYSE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        pmtLabel: 'Dialyse',
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, HAD_RADIO_HPTL: {
        label: 'Séance de radiothérapie en centre',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        originPlaceHolderHome: true,
        prefillDestinationServiceRaw: 'RADIOTHERAPIE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLB',
        pmtLabel: 'Radiothérapie',
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, HAD_RADIO_NOT_HPTL: {
        label: 'Séance de radiothérapie en structure libérale',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'B',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        isGovBIssuer: true,
        paymentStatus: 'GOV',
        isExoneratingAld: true,
        pmtLabel: 'Radiothérapie',
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, HAD_DIALYSIS_NOT_HPTL_NOT_PRTCL: {
        label: 'Séance de dialyse hors centre NON inscrite au protocole de soins',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'GOV',
        isExoneratingAld: true,
        pmtLabel: 'Dialyse',
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, HAD_DIALYSIS_NOT_HPTL_PRTCL: {
        label: 'Séance de dialyse hors centre inscrite au protocole de soins',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: {
            MCO: 'A',
            SSR: 'B',
            PSY: 'B',
        },
        payer: {
            MCO: 'HPTL_A',
            SSR: 'HPTL_B',
            PSY: 'HPTL_B',
        },
        govFlatRateClass: {
            MCO: 'TSE',
            SSR: null,
            PSY: null,
        },
        pmtLabel: 'Dialyse',
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, HAD_TSFR_URG_FINAL: {
        label: 'Transfert définitif aux urgences',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_FINAL',
        relatedGovFlatRateReason: 'HAD_TSFR_URG_TMP_EXAM',
        paymentStatus: 'GOV',
        prefillDestinationServiceRaw: 'URGENCES',
        prefillOriginWithMfuPlace: true,
        isUrgent: true,
        isUrgentAsap: true,
        originPlaceHolderHome: true,
        pmtLabel: 'Urgences',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, HAD_TSFR_URG_TMP_EXAM: {
        label: 'Transfert provisoire aux urgences',
        compatibleHospitalTypes: ['HAD'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        govFlatRateVerificationType: 'TSFR_TEMP',
        relatedGovFlatRateReason: 'HAD_TSFR_URG_FINAL',
        paymentStatus: 'HPTLA',
        prefillDestinationServiceRaw: 'URGENCES',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        pmtLabel: 'Urgences',
        isUrgent: true,
        isUrgentAsap: true,
        originPlaceHolderHome: true,
        govFlatRateClass: function (_a) {
            var mfdType = _a.mfdType;
            switch (mfdType) {
                case 'MCO':
                    return null;
                case 'SSR':
                    return 'ST5';
                case 'PSY':
                    return 'ST2';
            }
            (0, __1.assertUnreachable)(mfdType);
        },
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * DC
     */
    DC_SESSION_FROM_HPTL: {
        label: 'Séance de dialyse pour un patient hospitalisé dans un autre établissement',
        compatibleHospitalTypes: ['DC'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Dialyse',
        prefillDestinationWithMfuPlace: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        needInboundDepartureTimeConfirmation: true,
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, DC_SESSION_FROM_DOM: {
        label: 'Séance de dialyse pour un patient NON hospitalisé',
        compatibleHospitalTypes: ['DC'],
        pmtIssuer: 'A',
        payer: 'GOV',
        pmtLabel: 'Dialyse',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        isEligibleToAutoOrder: true,
        needInboundDepartureTimeConfirmation: true,
        isExoneratingAld: true,
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, DC_SESSION_FROM_HAD: {
        label: 'Séance de dialyse pour un patient en HAD',
        compatibleHospitalTypes: ['DC'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Dialyse',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        needInboundDepartureTimeConfirmation: true,
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, DC_SCAN_REP: {
        label: 'Scanner de repérage pour un patient hospitalisé ',
        compatibleHospitalTypes: ['DC'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Dialyse',
        prefillDestinationWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'SCANNER',
        patientSector: 'DEPARTURE',
    }, DC_DIALYSIS_ENTRNMT: {
        label: 'Entraînement à la dialyse pour un patient hospitalisé',
        compatibleHospitalTypes: ['DC'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Dialyse',
        prefillDestinationWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, DC_CS: {
        label: 'Consultation externe',
        compatibleHospitalTypes: ['DC'],
        pmtIssuer: 'A',
        payer: 'GOV',
        pmtLabel: 'Dialyse',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillSameDayUnknownTime: true,
        originPlaceHolderHome: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isExoneratingAld: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, DC_HC_SESSION_FROM_DOM: {
        label: 'Hospitalisation ambulatoire depuis le domicile',
        compatibleHospitalTypes: ['DC'],
        pmtIssuer: 'A',
        payer: 'GOV',
        pmtLabel: 'Dialyse',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        originPlaceHolderHome: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'GOV',
        isExoneratingAld: true,
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * RC
     */
    RC_SESSION_FROM_HPTL: {
        label: 'Séance de radiothérapie pour un patient hospitalisé dans un autre établissement',
        compatibleHospitalTypes: ['RC'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Radiothérapie',
        prefillDestinationWithMfuPlace: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, RC_SESSION_FROM_DOM: {
        label: 'Séance de radiothérapie pour un patient NON hospitalisé',
        compatibleHospitalTypes: ['RC'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        isEligibleToAutoOrder: true,
        isExoneratingAld: true,
        pmtLabel: 'Radiothérapie',
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, RC_SESSION_FROM_HAD: {
        label: 'Séance de radiothérapie pour un patient en HAD',
        compatibleHospitalTypes: ['RC'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Radiothérapie',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        isEligibleToAutoOrder: true,
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, RC_CENTRAGE: {
        label: 'Centrage pour un patient hospitalisé dans un autre établissement ',
        compatibleHospitalTypes: ['RC'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Radiothérapie',
        prefillDestinationWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, RC_IRR_EXT: {
        label: 'Préparation à irradiation externe pour un patient hospitalisé dans un autre établissement',
        compatibleHospitalTypes: ['RC'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Radiothérapie',
        prefillDestinationWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * CHIMIO
     */
    CHIM_SESSION_FROM_HPTL: {
        label: 'Séance de chimiothérapie pour un patient hospitalisé dans un autre établissement',
        compatibleHospitalTypes: ['CHIM'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Chimiothérapie',
        prefillDestinationWithMfuPlace: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'CHIMIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, CHIM_SESSION_FROM_DOM: {
        label: 'Séance de chimiothérapie pour un patient NON hospitalisé',
        compatibleHospitalTypes: ['CHIM'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        pmtLabel: 'Chimiothérapie',
        paymentStatus: 'GOV',
        isAldInvoiceable: true,
        isEligibleToAutoOrder: true,
        isExoneratingAld: true,
        spsTransportReason: 'CHIMIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, CHIM_SESSION_FROM_HAD: {
        label: 'Séance de chimiothérapie pour un patient en HAD',
        compatibleHospitalTypes: ['CHIM'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: 'TSE',
        pmtLabel: 'Chimiothérapie',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLA',
        isAldInvoiceable: true,
        spsTransportReason: 'CHIMIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, CHIM_CS_AND_BLOOD: {
        label: 'Consultation préalable aux séances pour un patient hospitalisé dans un autre établissement ',
        compatibleHospitalTypes: ['CHIM'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        pmtLabel: 'Chimiothérapie',
        prefillDestinationWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLB',
        isAldInvoiceable: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * Generic
     */
    ANY_EXIT_HPTL: {
        label: 'Retour à domicile / EHPAD / USLD ',
        compatibleHospitalTypes: ['FULL', 'HDJ', 'HAD', 'MDV', 'EHPAD', 'DC', 'RC', 'CHIM', 'URG', 'EPA'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'HOME',
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_OUT',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        pmtLabel: 'Retour à domicile',
        spsTransportReason: 'DEF_RETOUR_DOMICILE',
        patientSector: 'ARRIVAL',
    }, ANY_RETURN_MED_DEVICE: {
        label: 'Retour de matériel',
        compatibleHospitalTypes: ['FULL', 'HDJ', 'HAD', 'MDV', 'EHPAD', 'DC', 'RC', 'CHIM', 'URG', 'EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        pmtLabel: 'Matériel',
        spsTransportReason: 'LABORATOIRE',
        patientSector: 'DEPARTURE',
    }, ANY_ACH_PRLVT: {
        label: 'Acheminement prélèvements',
        compatibleHospitalTypes: ['FULL', 'HDJ', 'HAD', 'MDV', 'EHPAD', 'DC', 'RC', 'CHIM', 'URG', 'EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        pmtLabel: 'Prélèvements',
        spsTransportReason: 'LABORATOIRE',
        patientSector: 'DEPARTURE',
    }, ANY_EXIT_PRLVT: {
        label: 'Retour prélèvements',
        compatibleHospitalTypes: ['FULL', 'HDJ', 'HAD', 'MDV', 'EHPAD', 'DC', 'RC', 'CHIM', 'URG', 'EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillDestinationWithMfuPlace: true,
        isSingleTrip: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        pmtLabel: 'Prélèvements',
        spsTransportReason: 'LABORATOIRE',
        patientSector: 'DEPARTURE',
    }, ANY_UNINSURED_PTNT: {
        label: "Transport pris en charge par l'établissement pour patient sans droit",
        compatibleHospitalTypes: ['FULL', 'HDJ', 'HAD', 'MDV', 'EHPAD', 'DC', 'RC', 'CHIM', 'URG', 'EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, OTHER: {
        label: 'Autre', //* passenger.reason will have precedence
        compatibleHospitalTypes: ['FULL', 'HDJ', 'HAD', 'MDV', 'EHPAD', 'DC', 'RC', 'CHIM', 'URG', 'EPA'],
        pmtIssuer: null,
        payer: null,
        isOther: true,
        paymentStatus: function (_a) {
            var payer = _a.payer;
            if (!payer) {
                return null;
            }
            switch (payer) {
                case 'HPTL_A':
                case 'HPTL_A_NOTART80':
                    return 'HPTLA';
                case 'GOV':
                    return 'GOV';
                case 'PTNT':
                    return 'PTNT';
                case 'HPTL_B':
                case 'TPS_A':
                    return null;
            }
            (0, __1.assertUnreachable)(payer);
        },
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, ANY_CUSTOM_THIRDPARTY_HPTLA: {
        label: 'Autre', //* passenger.reason will have precedence
        compatibleHospitalTypes: ['FULL', 'HDJ', 'HAD', 'MDV', 'EHPAD', 'DC', 'RC', 'CHIM', 'URG', 'EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A',
        govFlatRateClass: null,
        paymentStatus: 'HPTLA',
        spsTransportReason: 'PAS_DE_RAISON',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * MDV
     */
    MDV_CS_COVID: {
        label: 'Consultation pour Covid-19',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: null,
        pmtLabel: 'Consultation',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, MDV_CS: {
        label: 'Consultation',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: null,
        pmtLabel: 'Consultation',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, MDV_RAD_SCAN: {
        label: 'Radio / Scanner',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: null,
        pmtLabel: 'Radio / Scanner',
        spsTransportReason: 'SCANNER',
        patientSector: 'DEPARTURE',
    }, MDV_IMAGE_NOT_RAD_SCAN: {
        label: 'Imagerie hors Radio / Scanner',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: null,
        pmtLabel: 'Imagerie',
        spsTransportReason: 'IRM',
        patientSector: 'DEPARTURE',
    }, MDV_IMAGE_AND_CS: {
        label: 'Imagerie + Consultation',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: null,
        pmtLabel: 'Consultation',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, MDV_TSFR_URG_COVID: {
        label: 'Transfert aux urgences pour Covid-19',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        isUrgent: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: null,
        isUrgentAsap: true,
        pmtLabel: 'Urgences',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, MDV_TSFR_URG: {
        label: 'Transfert aux urgences',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        isUrgent: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: null,
        isUrgentAsap: true,
        pmtLabel: 'Urgences',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, MDV_ENTER_HPTL: {
        label: 'Transfert pour hospitalisation',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: null,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, MDV_ENTER_HPTL_HDJ: {
        label: 'Transfert provisoire en HDJ',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: null,
        pmtLabel: 'Transfert',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, MDV_OTHER: {
        label: 'Autre',
        compatibleHospitalTypes: ['MDV'],
        pmtIssuer: null,
        payer: null,
        isOther: true,
        paymentStatus: null,
        spsTransportReason: 'PAS_DE_RAISON',
        patientSector: 'DEPARTURE',
    }, 
    /**
     * EPA
     */
    EPA_CS_NOTART80: {
        label: 'Consultation',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EPA_RAD_SCAN_NOTART80: {
        label: 'Radio / Scanner',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'SCANNER',
        patientSector: 'DEPARTURE',
    }, EPA_IMAGE_AND_CS_NOTART80: {
        label: 'Imagerie + Consultation',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EPA_IMAGE_NOT_RAD_SCAN_NOTART80: {
        label: 'Imagerie hors Radio / Scanner',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_BEFORE',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EPA_TSFR_FINAL_GOV: {
        label: 'Transfert définitif à la charge de la CPAM',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        spsTransportReason: 'DEF_RETOUR_DOMICILE',
        patientSector: 'DEPARTURE',
    }, EPA_TSFR_HPTL_TEMP_NOTART80: {
        label: 'Transfert provisoire (1 nuitée max)',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        needGovFlatRateTempTransferWarning: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, EPA_TSFR_URG_TMP_EXAM_NOTART80: {
        label: 'Transfert provisoire aux urgences',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'URGENCES',
        isUrgent: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'HOSP_SHORT_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        isUrgentAsap: true,
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, EPA_TSFR_URG_FINAL_GOV: {
        label: 'Transfert définitif aux urgences à la charge de la CPAM',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'URGENCES',
        isSingleTrip: true,
        isUrgent: true,
        appsoluTransportReason: 'HOSP_LONG_XFER',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        isUrgentAsap: true,
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, EPA_CHIM_HPTL: {
        label: 'Séance de chimiothérapie en centre',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'CHIMIOTHERAPIE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        spsTransportReason: 'CHIMIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, EPA_DIALYSIS_HPTL: {
        label: 'Séance de dialyse en centre',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'DIALYSE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        paymentStatus: 'HPTLB',
        spsTransportReason: 'DIALYSE',
        patientSector: 'DEPARTURE',
    }, EPA_RADIO_HPTL: {
        label: 'Séance de radiothérapie en centre',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'B',
        payer: 'HPTL_B',
        prefillOriginWithMfuPlace: true,
        prefillDestinationServiceRaw: 'RADIOTHERAPIE',
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        paymentStatus: 'HPTLB',
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, EPA_RADIO_NOT_HPTL: {
        label: 'Séance de radiothérapie en structure libérale',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'B',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        isRenewable: true,
        appsoluTransportReason: 'EXAMEN',
        timeStepInMinutes: 5,
        isGovBIssuer: true,
        paymentStatus: 'GOV',
        spsTransportReason: 'RADIOTHERAPIE',
        patientSector: 'DEPARTURE',
    }, EPA_ENTER_HPTL: {
        label: 'Entrée en hospitalisation depuis un domicile / EHPAD / USLD',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'HOME',
        cerfaArrival: 'FACILITY',
        prefillDestinationWithMfuPlace: true,
        originPlaceHolderHome: true,
        isSingleTrip: true,
        appsoluTransportReason: 'HOSP_IN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        spsTransportReason: 'TRANFERT',
        patientSector: 'DEPARTURE',
    }, EPA_PERM_NOTART80: {
        label: 'Permission thérapeutique (48h max)',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        needPermissionWarning: true,
        isRenewable: true,
        appsoluTransportReason: 'HOSP_OUT',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'SORTIE_THERAPEUTIQUE',
        patientSector: 'DEPARTURE',
    }, EPA_VAD_NOTART80: {
        label: 'Visite à domicile',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        destinationPlaceHolderHome: true,
        appsoluTransportReason: 'HOSP_OUT',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, EPA_VISIT_EHPAD_NOTART80: {
        label: 'Visite de pré-admission en EHPAD à la charge de votre établissement',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'EXAMEN',
        patientSector: 'DEPARTURE',
    }, EPA_VISIT_EHPAD_PTNT: {
        label: 'Visite de pré-admission en EHPAD à la charge du patient',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'PTNT',
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'PTNT',
        spsTransportReason: 'CONVENANCE_PERSONNELLE',
        patientSector: 'DEPARTURE',
    }, EPA_CS_FROM_EPA_NOTART80: {
        label: 'AR MF - Autre à charge HPTL_A_NOTART80',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EPA_CS_FROM_EPA_PTNT: {
        label: 'AR MF - Autre à charge PTNT',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'PTNT',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'PTNT',
        spsTransportReason: 'CONVENANCE_PERSONNELLE',
        patientSector: 'DEPARTURE',
    }, EPA_CS_FROM_EPA_GOV: {
        label: 'AR MF - Autre à charge CPAM',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        prefillOriginWithMfuPlace: true,
        prefillSameDayUnknownTime: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EPA_TSFR_FROM_EPA_NOTART80: {
        label: 'AS MF - Autre à charge HPTL_A_NOTART80',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'HPTL_A_NOTART80',
        isSingleTrip: true,
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'HPTLA',
        spsTransportReason: 'CONSULTATION',
        patientSector: 'DEPARTURE',
    }, EPA_TSFR_FROM_EPA_PTNT: {
        label: 'AS MF - Autre à charge PTNT',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'PTNT',
        isSingleTrip: true,
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'PTNT',
        spsTransportReason: 'CONVENANCE_PERSONNELLE',
        patientSector: 'DEPARTURE',
    }, EPA_TSFR_FROM_EPA_GOV: {
        label: 'AS MF - Autre à charge CPAM',
        compatibleHospitalTypes: ['EPA'],
        pmtIssuer: 'A',
        payer: 'GOV',
        cerfaDeparture: 'FACILITY',
        cerfaArrival: 'FACILITY',
        isSingleTrip: true,
        prefillOriginWithMfuPlace: true,
        appsoluTransportReason: 'EXAMEN',
        alternativePickupTimeMode: 'APT_AROUND',
        paymentStatus: 'GOV',
        spsTransportReason: 'DEF_RETOUR_DOMICILE',
        patientSector: 'DEPARTURE',
    } }, deprecatedReasons);
var defaultTransportReasons = {
    HDJ: 'HDJ_FROM_DOM',
};
var hcMfdTypes = ['MCO', 'PSY', 'SSR'];
function getMapping(transportReason, clone) {
    if (clone === void 0) { clone = false; }
    var mapping = clone ? (0, lodash_1.cloneDeep)(exports.reasonMappings[transportReason]) : exports.reasonMappings[transportReason];
    if (!mapping) {
        throw new Error("[rules] Can't process non existant transport reason ".concat(transportReason));
    }
    return mapping;
}
function getReasonRules(transportReason, hospitalType, mfdType, isSameMfdType, vehicle, departureTime, payer) {
    var mapping = getMapping(transportReason, true);
    if (mapping.isDeprecated) {
        throw new Error("[rules] Can't process DEPRECATED transport reason ".concat(transportReason));
    }
    if (!mapping.compatibleHospitalTypes.includes(hospitalType)) {
        throw new Error("[rules] Incompatible transport reason ".concat(transportReason, " and hospital type ").concat(hospitalType));
    }
    // Resolve payer: determine the initial payer based on mapping configuration
    var resolveInitialPayer = function () {
        if (typeof mapping.payer === 'string' || mapping.payer === null) {
            return mapping.payer;
        }
        if (!hcMfdTypes.includes(mfdType)) {
            throw new Error("[rules] Can't compute payer for MFD type ".concat(mfdType));
        }
        if (typeof mapping.payer === 'function') {
            return mapping.payer({ mfdType: mfdType, isSameMfdType: isSameMfdType, departureTime: departureTime });
        }
        return mapping.payer[mfdType] || null;
    };
    var initialPayer = resolveInitialPayer();
    // * Payer override due to Vehicle exceptions, only for non-HPTL_A passengers
    var hasVehicleException = function () {
        var isMedicalVehicle = (0, __1.isIn)(['MEDICAL', 'PARAMEDICAL'], vehicle);
        // * Override all passengers payers if departure is before Jan 1st 2023
        var isBeforeJan2023 = (0, moment_1.default)(departureTime).isBefore('2023-01-01');
        return isMedicalVehicle && (isBeforeJan2023 || initialPayer !== 'HPTL_A');
    };
    // Set final payer value
    mapping.payer = hasVehicleException() ? 'HPTL_A_NOTART80' : initialPayer;
    // Resolve PMT issuer
    mapping.pmtIssuer = (function () {
        // Payer exceptions
        switch (mapping.payer) {
            case 'PTNT':
            case 'HPTL_A_NOTART80':
            case 'TPS_A':
                return null;
        }
        if (typeof mapping.pmtIssuer === 'string' || mapping.pmtIssuer === null) {
            return mapping.pmtIssuer;
        }
        if (!hcMfdTypes.includes(mfdType)) {
            throw new Error("[rules] Can't compute PMT issuer for MFD type ".concat(mfdType));
        }
        if (typeof mapping.pmtIssuer === 'function') {
            return mapping.pmtIssuer({ mfdType: mfdType, isSameMfdType: isSameMfdType, departureTime: departureTime });
        }
        return mapping.pmtIssuer[mfdType] || null;
    })();
    // Resolve payment status
    mapping.paymentStatus = (function () {
        if (hasVehicleException()) {
            return 'HPTLA';
        }
        if (typeof mapping.paymentStatus === 'string' || mapping.paymentStatus === null) {
            return mapping.paymentStatus;
        }
        if (typeof mapping.paymentStatus === 'function') {
            return mapping.paymentStatus({ mfdType: mfdType, isSameMfdType: isSameMfdType, payer: payer, departureTime: departureTime });
        }
        return mapping.paymentStatus[mfdType] || null;
    })();
    // Resolve HPTL_A properties
    if (mapping.payer === 'HPTL_A') {
        var retroCompatibilityPre2024 = function (govFlatRateClass) {
            if (!govFlatRateClass) {
                return null;
            }
            // * Pre-2024, SSR's ST4/ST5/ST6 flat rates do not not exist.
            if (mfdType === 'SSR' &&
                (0, __1.isIn)(['ST4', 'ST5', 'ST6'], govFlatRateClass) &&
                (0, moment_1.default)(departureTime).isBefore('2024-01-01', 'day')) {
                var govFlatRateClass_ = govFlatRateClass;
                var retroCompatibilityMapping = {
                    ST4: 'ST1',
                    ST5: 'ST2',
                    ST6: 'ST3',
                };
                return retroCompatibilityMapping[govFlatRateClass_];
            }
            return govFlatRateClass;
        };
        mapping.govFlatRateClass = retroCompatibilityPre2024((function () {
            if (!mapping.govFlatRateClass) {
                return null;
            }
            if (typeof mapping.govFlatRateClass === 'string' || mapping.govFlatRateClass === null) {
                return mapping.govFlatRateClass;
            }
            if (!hcMfdTypes.includes(mfdType)) {
                throw new Error("[rules] Can't compute Gov flat rate for MFD type ".concat(mfdType));
            }
            if (typeof mapping.govFlatRateClass === 'function') {
                return mapping.govFlatRateClass({ mfdType: mfdType, isSameMfdType: isSameMfdType, departureTime: departureTime });
            }
            return mapping.govFlatRateClass[mfdType] || null;
        })());
    }
    else {
        mapping.govFlatRateClass = null;
    }
    // Null GOV properties if not GOV
    if (mapping.payer !== 'GOV') {
        mapping.cerfaDeparture = null;
        mapping.cerfaArrival = null;
    }
    return mapping;
}
function prefillTransportReason(hospitalType) {
    var _a;
    return (_a = defaultTransportReasons[hospitalType]) !== null && _a !== void 0 ? _a : null;
}
function destinationPlaceholder(reason) {
    if (getMapping(reason).destinationPlaceHolderHome) {
        return 'Adresse du domicile';
    }
    return "Nom ou adresse de l'établissement d'arrivée";
}
function originPlaceholder(reason) {
    if (getMapping(reason).originPlaceHolderHome) {
        return 'Adresse du domicile';
    }
    return "Nom ou adresse de l'établissement de départ";
}
// This function can be used to make a typed resolver for a particular rule
// that only depends on the transport reason
function makeReasonRuleResolver(property, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return function (reason) { var _a; return reason ? ((_a = getMapping(reason)[property]) !== null && _a !== void 0 ? _a : defaultValue) : defaultValue; };
}
// This function can be used to generate an array of transport reasons for which
// a specific property is TRUE
function makeReasonArrayFromRule(property) {
    return (0, __1.getKeys)(exports.reasonMappings).filter(function (reason) { var _a; return Boolean((_a = exports.reasonMappings[reason]) === null || _a === void 0 ? void 0 : _a[property]); });
}
exports.reasonRules = {
    getLabel: function (reason, raw) {
        if (raw === void 0) { raw = ''; }
        if (raw) {
            return raw;
        }
        if (!reason) {
            return null;
        }
        return getMapping(reason)['label'];
    },
    getPmtLabel: makeReasonRuleResolver('pmtLabel'),
    getPaymentStatus: makeReasonRuleResolver('paymentStatus'),
    getAppsoluTransportReason: makeReasonRuleResolver('appsoluTransportReason', 'MEDICAL'),
    getCerfaDeparture: makeReasonRuleResolver('cerfaDeparture', 'FACILITY'),
    getCerfaArrival: makeReasonRuleResolver('cerfaArrival', 'FACILITY'),
    isOtherReason: makeReasonRuleResolver('isOther'),
    isUrgentReason: makeReasonRuleResolver('isUrgent'),
    isUrgentAsapReason: makeReasonRuleResolver('isUrgentAsap'),
    isGovB: makeReasonRuleResolver('isGovBIssuer'),
    shouldToggleSingleTrip: makeReasonRuleResolver('isSingleTrip'),
    shouldPrefillOrigin: makeReasonRuleResolver('prefillOriginWithMfuPlace'),
    shouldPrefillDestination: makeReasonRuleResolver('prefillDestinationWithMfuPlace'),
    shouldPrefillSameDayUnknownTime: makeReasonRuleResolver('prefillSameDayUnknownTime'),
    shouldAskForSameMfdType: makeReasonRuleResolver('toggleIsSameMfdType'),
    shouldHideOriginServiceInput: makeReasonRuleResolver('originPlaceHolderHome'),
    shouldHideDestinationServiceInput: makeReasonRuleResolver('destinationPlaceHolderHome'),
    shouldShowTempWarning: makeReasonRuleResolver('needGovFlatRateTempTransferWarning'),
    shouldShowPermWarning: makeReasonRuleResolver('needPermissionWarning'),
    govFlatRateVerificationType: makeReasonRuleResolver('govFlatRateVerificationType'),
    relatedGovFlatRateReason: makeReasonRuleResolver('relatedGovFlatRateReason'),
    prefillTransportReason: prefillTransportReason,
    prefillDestinationServiceRaw: makeReasonRuleResolver('prefillDestinationServiceRaw'),
    destinationPlaceholder: destinationPlaceholder,
    originPlaceholder: originPlaceholder,
    renewableReasons: makeReasonArrayFromRule('isRenewable'),
    autoOrderReasons: makeReasonArrayFromRule('isEligibleToAutoOrder'),
    needInboundDepartureTimeConfirmationReasons: makeReasonArrayFromRule('needInboundDepartureTimeConfirmation'),
    exoneratingAldReasons: makeReasonArrayFromRule('isExoneratingAld'),
    timeStepInMinutes: makeReasonRuleResolver('timeStepInMinutes', 15),
};
/**
 * Get all transport reason options that are not deprecated and are compatible with the given hospital type
 */
function getAvailableTransportReasonOptions(hospitalType) {
    return (0, __1.getKeys)(exports.reasonMappings).filter(function (reason) {
        var _a;
        return !exports.reasonMappings[reason].isDeprecated &&
            !exports.reasonMappings[reason].isHidden &&
            ((_a = exports.reasonMappings[reason].compatibleHospitalTypes) === null || _a === void 0 ? void 0 : _a.includes(hospitalType));
    });
}
var isLddTransportReason = function (reason) { return exports.reasonRules.renewableReasons.includes(reason); };
exports.isLddTransportReason = isLddTransportReason;
var isExoneratingAldTransportReason = function (reason) {
    return exports.reasonRules.exoneratingAldReasons.includes(reason);
};
exports.isExoneratingAldTransportReason = isExoneratingAldTransportReason;
var isEligibleToAutoOrder = function (reason) { return exports.reasonRules.autoOrderReasons.includes(reason); };
exports.isEligibleToAutoOrder = isEligibleToAutoOrder;
var needInboundDepartureTimeConfirmation = function (reason) {
    return exports.reasonRules.needInboundDepartureTimeConfirmationReasons.includes(reason);
};
exports.needInboundDepartureTimeConfirmation = needInboundDepartureTimeConfirmation;
//# sourceMappingURL=rules.js.map